import store from "./module/store";

export default {
  name: "advanced-forms",
  routes: [],
  store: store
};
